import { Spacing } from '@vkontakte/vkui';
import React from 'react';
import {
    aiPhotoImprovingBillingPopupTitle,
    aiPhotoImprovingThreeTariffsListId,
    aiPhotoImprovingThreeTariffsPopupTitle,
} from 'reactApp/appHelpers/featuresHelpers/features/aiPhotoImproving';
import { cdnPackagesUrl } from 'reactApp/appHelpers/themeToolHelpers/default-values';
import { renderCommonWhatsNewDialog } from 'reactApp/components/WhatsNewDialog/WhatsNewDialog.helpers';
import { openBuyDisableAds, openTariffBuy } from 'reactApp/modules/payment/payment.module';
import { closePopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';
import { store as reduxStore } from 'reactApp/store';
import type { Product } from 'reactApp/types/Billing';
import { ETabsName } from 'reactApp/ui/TariffSectionNew/TariffSection.constants';
import { sendDwh } from 'reactApp/utils/ga';

import styles from './AiPhotoImprovingModal.css';

const sendRadar = (action: 'show' | 'click' | 'close', isSecondStepPromo?: boolean) => {
    sendDwh({
        eventCategory: 'modal',
        action,
        dwh_enabled: true,
        dwhData: { name: isSecondStepPromo ? 'mnz_ai_improve_modal2s_home' : 'mnz_ai_improve_modal_home' },
    });
};

interface RenderAiPhotoImprovingModalParams {
    onComplete?: () => void;
    onClose?: () => void;
    isSecondStepPromo?: boolean;
}

export const renderAiPhotoImprovingModal = (params?: RenderAiPhotoImprovingModalParams) => {
    // eslint-disable-next-line init-declarations, prefer-const
    let closeDialog: (() => void) | undefined;

    const paySource = `ai-improve-modal${params?.isSecondStepPromo ? '2s' : ''}`;

    const primaryClickHandler = () => {
        sendRadar('click', params?.isSecondStepPromo);
        closeDialog?.();

        reduxStore.dispatch(
            openBuyDisableAds({
                title: aiPhotoImprovingThreeTariffsPopupTitle,
                tariffsNumber: aiPhotoImprovingThreeTariffsListId,
                activeTab: ETabsName.year,
                isFrame: false,
                onBuyClick: (product: Product) =>
                    reduxStore.dispatch(
                        openTariffBuy({
                            productId: product.id,
                            paySource,
                            onSuccess: () => {
                                closePopupHelper(popupNames.BUY_DISABLE_ADS);
                                params?.onComplete?.();
                            },
                            title: aiPhotoImprovingBillingPopupTitle,
                        })
                    ),
                paySource,
            })
        );
    };

    closeDialog = renderCommonWhatsNewDialog({
        title: <span>Нейросеть улучшит качество фото, а эмоции сохранит</span>,
        content: (
            <div data-test-id="ai-fakedoor-modal">
                <Spacing size={16} />
                <span>
                    Уберёт шум, добавит контрастности, поможет передать момент. С&nbsp;Mail&nbsp;Space можно улучшить 20&nbsp;фото
                    в&nbsp;день, без&nbsp;подписки&nbsp;— одно
                </span>
                <Spacing size={32} />
            </div>
        ),
        primaryButtonText: <span>Подключить за&nbsp;1&nbsp;₽</span>,
        imageUrl: '',
        imageOnlyAdditionalContent: true,
        imageAdditionalContent: (
            <video src={`${cdnPackagesUrl}/static/cloud/ai/photo-improving/modal.mp4`} autoPlay muted loop className={styles.video} />
        ),
        onClick: primaryClickHandler,
        onDismiss: () => {
            params?.onClose?.();
            sendRadar('close', params?.isSecondStepPromo);
        },
        onShow: () => {
            sendRadar('show', params?.isSecondStepPromo);
        },
        dialogSize: 'tiny',
        buttonTheme: 'vk',
        className: styles.root,
        contentClassName: styles.content,
        closeIconClassName: styles.closeIcon,
    })?.closeDialog;
};
